import type { FC } from "react"
import { useContext, useEffect } from "react"
import { useParams } from "react-router-dom"

import strings from "../assets/strings"
import { TabActiveContext } from "../components/contexts/TabActiveContext"
import CENavigationMenu from "../components/layout/CENavigationMenu"
import { Main } from "../components/layout/Main"
import ErrorScreen from "../components/screens/ErrorScreen"
import { TabPlaylists } from "../components/screens/TabPlaylists/TabPlaylists"
import { CETextPoppins } from "../components/ui"
import { useGetExposition } from "../services/useQueries"

export const PlaylistsPage: FC = () => {
  const { expoId } = useParams()

  const { tabActive, updateTabActive } = useContext(TabActiveContext)

  const {
    data: exposition,
    isLoading,
    isError: isErrorExposition,
  } = useGetExposition(expoId)

  useEffect(() => {
    if (tabActive !== "playlists") {
      updateTabActive("playlists")
    }
  }, [expoId, exposition, tabActive, updateTabActive])

  if (isLoading) {
    return <CETextPoppins>{strings.general.loading}</CETextPoppins>
  }

  if (isErrorExposition || !exposition || exposition.isExternal) {
    return <ErrorScreen />
  }
  return (
    <Main>
      <div className="row-container">
        <CENavigationMenu />
        <TabPlaylists
          isPublishedExpo={exposition.published}
          isLoading={isLoading}
          expositionId={exposition.id}
          playlists={exposition.playlist || []}
          languagesAvailable={exposition.languages}
        />
      </div>
    </Main>
  )
}
